import { layouts, devices } from '../../config/theme'
import {
  widthHeight100,
  flex,
  alignCenter,
  pointer,
  asPx,
  hidden,
  width100
} from '../../utils/jss-utils'

const style = {}

style.base = {
  ...flex,
  ...alignCenter,
  ...width100,
  transition: 'all .35s'
}

style.content = {
  ...pointer,
  '& img': {
    height: '25px',
    filter: 'invert(1)'
  }
}

style.hideOnMobile = {}
style.hideOnDesktop = {}

style.hideOnMobile[devices.mobile] = { ...hidden }
style.hideOnDesktop[devices.desktop] = { ...hidden }

style.base[devices.mobile] = {
  ...widthHeight100,
  maxHeight: asPx(layouts.desktopHeader.height),
  minHeight: asPx(layouts.desktopHeader.height),
  paddingLeft: '25px'
}
style.base[devices.desktop] = {
  maxHeight: asPx(layouts.header.height),
  minHeight: asPx(layouts.header.height),
  paddingLeft: '40px',
  paddingRight: '40px'
}

export default style
